import { CrowdStrike } from '../crowdstrike/models/CrowdStrike';
import { JiraExport } from '../jira/models/JiraExport';
import { JiraIssueCollector } from '../jira/models/JiraIssueCollector';
import { ServiceNowIntegration } from '../service-now/models/ServiceNowIntegration';
import { Tanium } from '../tanium/models/Tanium';
import { Venafi } from '../venafi/models/Venafi';

export type Integration = JiraIssueCollector | JiraExport | Venafi | Tanium | CrowdStrike | ServiceNowIntegration;

export class Integrations {
  constructor(
    private readonly jiraExport: JiraExport | null,
    private readonly jiraIssueCollector: JiraIssueCollector | null,
    private readonly venafi: Venafi | null,
    private readonly tanium: Tanium | null,
    private readonly crowdStrike: CrowdStrike | null,
    private readonly serviceNow: ServiceNowIntegration | null
  ) {}

  getJiraIssueCollector() {
    return this.jiraIssueCollector;
  }

  getJiraExport() {
    return this.jiraExport;
  }

  getVenafi() {
    return this.venafi;
  }

  getTanium() {
    return this.tanium;
  }

  getCrowdStrike() {
    return this.crowdStrike;
  }

  getServiceNow() {
    return this.serviceNow;
  }
}
